import { Direction } from '@angular/cdk/bidi';
import {
  ChangeDetectionStrategy,
  Component,
  ContentChildren,
  EventEmitter,
  Input,
  OnDestroy,
  Output,
  QueryList,
  TemplateRef,
  ViewChild
} from '@angular/core';
import { MenuItemComponent } from '../menu-item/menu-item.component';

export type MenuCloseReason = void | 'click' | 'keydown' | 'tab';
let uniqueIdCounter = 0;
@Component({
    selector: 'sim-menu-panel',
    templateUrl: './menu-panel.component.html',
    styleUrls: ['./menu-panel.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        '[id]': 'id'
    },
    standalone: false
})
export class MenuPanelComponent implements OnDestroy {
  @Output() readonly closed: EventEmitter<MenuCloseReason> = new EventEmitter<MenuCloseReason>();
  @ViewChild(TemplateRef) templateRef!: TemplateRef<any>;
  @ContentChildren(MenuItemComponent, { descendants: false })
  items!: QueryList<MenuItemComponent>;
  @Input() id: string = `sim-menu-panel-${uniqueIdCounter++}`;

  uiLoginMenu?: boolean;
  xPosition = 'after';
  yPosition = 'below';
  direction!: Direction;

  ngOnDestroy(): void {
    this.closed.complete();
  }
}
